import { useState, useEffect } from 'react';
import { consumirApi } from '../../../../utils/consumoApi';

const useCargaInicial = () => {
  const [tiposProyectoDatos, setTiposProyectoDatos] = useState([]);
  const [tiposTerrenoDatos, setTiposTerrenoDatos] = useState([]);
  const [formaPagoDatos, setFormaPagoDatos] = useState([]);
  const [espaciosDatos, setEspaciosDatos] = useState([]);
  const [plazoElaboracionDatos, setPlazoElaboracionDatos] = useState([]);
  const [cargando, setCargando] = useState(true); // Indicador de carga
  const [idFormaPago, setIdFormaPago] = useState('');
  const [formaPago, setFormaPago] = useState(null);
  const idEmpresa = JSON.parse(localStorage.getItem('empresa'))

  // Obtener tipos de proyecto
  const obtenerTipoProyecto = async () => {
    const respuesta = await consumirApi('GET', `maestros/tipo-proyecto/${idEmpresa}`);
    setTiposProyectoDatos(respuesta.data);
    setCargando(false);
  };

  // Obtener tipos de terreno
  const obtenerTipoTerreno = async () => {
    const respuesta = await consumirApi('GET', `maestros/tipo-terreno/${idEmpresa}`);
    setTiposTerrenoDatos(respuesta.data);
    setCargando(false);
  };

  // Obtener formas de pago
  const obtenerFormaPago = async () => {
    const respuesta = await consumirApi('GET', `maestros/forma-pago-detalle/${idEmpresa}`);
    setFormaPagoDatos(respuesta.data);
    setCargando(false);
  };

  // Obtener formas de pago
  const obtenerEspacio = async () => {
    const respuesta = await consumirApi('GET', `maestros/espacio/${idEmpresa}`);
    setEspaciosDatos(respuesta.data);
    setCargando(false);
  };

  // Manejador para el cambio de forma de pago
  const manejadorFormaPago = (idFormaPago) => {
    if (idFormaPago !== '') {
      setIdFormaPago(idFormaPago);
      // carga solo los datos de la forma de pago seleccionada para que sea usada para generar las cuotas de los paquete s
      const formaPagoSeleccionado = formaPagoDatos.find((formaPago) => formaPago.id == idFormaPago);
      setFormaPago(formaPagoSeleccionado);
    }
  };

   // Obtener plazos de elaboracion
   const obtenerPlazoElaboracion = async () => {
    const respuesta = await consumirApi('GET', `maestros/plazo/${idEmpresa}`);
    setPlazoElaboracionDatos(respuesta.data);
    setCargando(false);
  };

  useEffect(() => {
    obtenerTipoProyecto();
    obtenerTipoTerreno();
    obtenerFormaPago();
    obtenerEspacio();
    obtenerPlazoElaboracion()
  }, []); // Solo ejecuta una vez cuando el componente se monta

  return {
    tiposProyectoDatos,
    tiposTerrenoDatos,
    formaPagoDatos,
    espaciosDatos,
    cargando,
    idFormaPago,
    formaPago,
    plazoElaboracionDatos,
    manejadorFormaPago
  };
};

export default useCargaInicial;
